// extracted by mini-css-extract-plugin
export default {"root":"_1xsl8","body":"_3CPs6","footer":"XIEgu"};